import {
    Button,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from "@material-ui/core";
import * as React from "react";
import {useContext, useState} from "react";
import {
    ErrorCommon,
    EstimationErrorCommon,
    SelectField,
    TextField,
    TextFieldCommon,
} from "../../components/formikFormInputs";
import * as EstimationActions from "../../actions/estimation";
import { useActions } from "../../actions";
import { useFormikContext } from "formik";
import FormControl from "@material-ui/core/FormControl";
import * as EstimatorActions from "../../actions/estimator";
import {
    addPlus,
    allocationFieldForm,
    allocationMapper,
    allocationsMapperWithCarrierLabels,
    checkLabelExist,
    createInitialValues,
    customInvestmentTypeFieldName,
    distributionLoanRate,
    getBonusFieldNameWithLabel,
    getBonusFieldNameWithLabelPostfix,
    getCodeFromLabelAndBonus,
    getGrowthFieldName,
    getPercentageFieldName,
    InvestmentValues,
    InvestmentValuesLabel,
    isSuffixExist,
} from "../../pages/client/Estimation/utils/utils";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { getCarrierCode } from "../../utils/commonUtils";
import InfoIcon from "@material-ui/icons/Info";
import {StepFourPopUp} from "../../pages/client/Estimation/V1/Components/StepFourPopUp";
import EstimationFormContext from "../../pages/client/Estimation/V1/Context/EstimationFormContext";
import {required} from "../../utils/validation";
import * as clientActions from "../../actions/client";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { makeStyles } from '@material-ui/core/styles';
import { AccountType } from "../../constants";
import { AllianzLifeCarrierDetail } from "../../constants";

type userDetailsInterFace = {
    carrierId: any
    strategyId: any
}

const bonusLabels = {
    1: { code: "select" , label: "Select"},
    2: { code: "classic" , label: "Classic"},
    3: { code: "standard" , label: "Standard"},
    4: { code: "bonus" , label: "Bonus"},
}

type Allocation = {
    allocationname: string;  // or number if it's always numeric
    allocationrate: number;
    allocationweight: number;
};

type Item = {
    label: string;
    code: string;
};

const useLinesStyles = makeStyles({
    lineContainer: {
        position: 'relative',
        width: 30,
        height: '100%',
    },
    vertical: {
        position: 'absolute',
        left: 20,
        top: -75,
        bottom: 0,
        width: 5,
        backgroundColor: '#bdbdbd',
        height: 80,
    },
    horizontal: {
        position: 'absolute',
        left: 24,
        top: '50%',
        width: 120,
        height: 5,
        backgroundColor: '#bdbdbd',
    }
});

export const InitializeValue = ({allocations}: {allocations: Allocation[]}) => {
    const {values, setFieldValue} = useFormikContext<any>()
    const { user }: any = useSelector((state: RootState) => state.auth);
    const carrierId = (user.accessType === "client" ? user.demoCarrierId : (user.client && user.client.carrier ? user.client.carrier.id : 2));
    React.useEffect(() => {
        if(allocations){
            setTimeout(() => {
                const initialValues = createInitialValues(values, allocations, carrierId)
                console.log("initialValues", initialValues)
                Object.keys(initialValues).forEach(key => {
                    setFieldValue(key, initialValues[key])
                })
            },1000)
        }
    },[allocations, values[allocationFieldForm]])

    return <></>
}

const InvitationAllocations = (props: {
    callingFrom: string,
    userDetails?: userDetailsInterFace,
    confirmAllocation?: boolean
    clientDetails?: any
}) => {
    const { callingFrom, userDetails, confirmAllocation = true, clientDetails } = props;
    const { values, errors, touched, handleChange, setFieldValue, validateForm }: any = useFormikContext();
    const cActions = useActions(clientActions);
    const estimationActions = useActions(EstimationActions);
    const estimatorActions = useActions(EstimatorActions);
    const { estimatorId } = useContext<any>(EstimationFormContext);
    const { user }: any = useSelector((state: RootState) => state.auth);
    const carrierId = (userDetails && userDetails.carrierId) || (user.accessType === "client" ? user.demoCarrierId : (user.client && user.client.carrier ? user.client.carrier.id : 2));
    const [estimatorDataId, setEstimatorDataId] = React.useState<any | null>(estimatorId);
    const [estimatorData, setEstimatorData] = React.useState<any | null>({});
    const strategyId = (userDetails && userDetails.strategyId) || (user.accessType === "client" ? user && user.demoStrategy && user.demoStrategy.id : user && user.client && user.client.strategy && user.client.strategy.id || 1);
    const [allocationQuestion, setAllocationQuestion] = useState({});
    const [bonusOptions, setBonusOptions] = React.useState<any>([])
    const isAlZ = getCarrierCode(carrierId) == "ALZ";
    const [open, setOpen] = React.useState(false);
    const [checkAB, setCheckAB] = React.useState({});
    const clientAllocationsData = clientDetails && clientDetails.client && clientDetails.client.clientAllocations || [];
    const allQuestion = allocationsMapperWithCarrierLabels[carrierId] || [];
    const [questionsToShow, setQuestionsToShow] = React.useState(allQuestion);
    const [columns, setColumns] = React.useState(questionsToShow);
    const staticQuestions = ["5", "7", "47", "3"];
    const sortedQuestionsValues = ["101", "77", "86", "131", "125", "128", "130", "124", "127", "123", "126", "129", ...staticQuestions];
    const [bonusCount, setBonusCount] = React.useState(0);
    const classes = useLinesStyles();

    const standard = 3;

    const calculateGrowthRate = () => {
        return columns && columns.reduce((total, code) => {
            const label = getLabel(code);
            const doHaveBonus = allocationQuestion[code] && allocationQuestion[code].doHaveBonus;
            const percentageName = getPercentageFieldName(doHaveBonus, label, code);
            const growthName = getGrowthFieldName(label, code);
            if (allocationQuestion && allocationQuestion[code] && values[percentageName]) {
                return total + (Number(values[growthName]) * Number(values[percentageName]) / 100);
            }
            return total;
        }, 0);
    };

    const getEstimatorDataFromApi = async (query: Partial<{ strategyId: number, carrierId: number }>) => {
        if (query.carrierId && query.strategyId) {
            const res = await estimatorActions.getEstimatorDetails(query);
            if (!!res) {
                setEstimatorDataId(res.id);
                setEstimatorData(res);
            }
        }
    };

    const getLabel = (code) =>{
        return  (allocationQuestion[code] &&  allocationQuestion[code].label) || ""
    }

    const getBonusOptions = React.useCallback( (code)=>{
        const label = getLabel(code)
        const bonusMapper = {};
        Object.keys(allocationQuestion).forEach((key)=>{
            const question = allocationQuestion[key]
            if(bonusLabels[question.bonusType]){
                if(bonusMapper[question.label]){
                    bonusMapper[question.label].push({
                        key: question.bonusType,
                        value: question.bonusType,
                        name:bonusLabels[question.bonusType].label,
                    })
                }else{
                    bonusMapper[question.label] = [{
                        key: question.bonusType,
                        value: question.bonusType,
                        name:bonusLabels[question.bonusType].label,
                    }]
                }
            }
        })
        return bonusMapper[label] || []
    },[allocationQuestion])

    React.useEffect(() => {
        if (!estimatorId || !(estimatorData && estimatorData.id)) {
            let query: Partial<{ strategyId: number, carrierId: number }> = {};
            query = {
                strategyId: strategyId,
                carrierId: carrierId,
            };
            getEstimatorDataFromApi(query).then(() => {
            });
        }
    }, [strategyId, carrierId]);

    const initAllocations = () => {
        if (selInvestment) {
            setFieldValue("totalPercentage", 100);
            const avgPercentage = (100 / selInvestment.question.length);
            const getCode = getCodeFromLabelAndBonus(allocationQuestion);
            columns.forEach((code) => {
                const label = getLabel(code);
                const doHaveBonus = allocationQuestion[code] && allocationQuestion[code].doHaveBonus;
                const percentageName = getPercentageFieldName(doHaveBonus, label, code);
                const questionExistInSelect = checkLabelExist(allocationQuestion, selInvestment.question, getLabel(code));
                const bonusTypeVal = allocationQuestion && allocationQuestion[code] && allocationQuestion[code].bonusType;
                const bonusFieldName = getBonusFieldNameWithLabelPostfix(label, code, bonusTypeVal);
                const growthName = getGrowthFieldName(label, code);
                // question according to investment type will set their value
                if (questionExistInSelect) {
                    setFieldValue(percentageName, avgPercentage);
                    setFieldValue(bonusFieldName, questionExistInSelect.bonusType);
                } else {
                    setFieldValue(percentageName, "");
                }
                if (allocationQuestion[code]) {
                    // code according to bonus type and selected label and this same question code which will save in client allocations
                    const ClientCode = getCode(getLabel(code), allocationQuestion[code].bonusType);
                    setFieldValue(growthName, questionExistInSelect.percentage || allocationQuestion[ClientCode] && allocationQuestion[ClientCode].percentage);
                }
            });
        } else {
            columns.forEach((code) => {
                const label = getLabel(code);
                const growthName = getGrowthFieldName(label, code);
                const getCode = getCodeFromLabelAndBonus(allocationQuestion);
                if (allocationQuestion[code]) {
                    // code according to bonus type and selected label and this same question code which will save in client allocations
                    const ClientCode = getCode(getLabel(code), allocationQuestion[code].bonusType);
                    setFieldValue(growthName, allocationQuestion[ClientCode] && allocationQuestion[ClientCode].percentage);
                }
            });
            Array.isArray(columns) && columns.forEach((code) => {
                const label = getLabel(code);
                const bonusTypeVal = allocationQuestion && allocationQuestion[code] && allocationQuestion[code].bonusType;
                const bonusFieldName = getBonusFieldNameWithLabelPostfix(label, code, bonusTypeVal);
                if (allocationQuestion[code] && allocationQuestion[code].doHaveBonus) {
                    !values[getBonusFieldNameWithLabel(getLabel(code))] && setFieldValue(bonusFieldName, getBonusOptions(code)[0] && getBonusOptions(code)[0].value);
                }
            });
        }
        setTimeout(() => {
            validateForm();
        }, 1000);
    };

    const standardBonusObject = {
        key: standard,
        value: standard,
        name: "Standard",
    }

    React.useEffect(()=>{
      (async () =>{
            const res = await cActions.getAllocationsBonus();
            if(res && Array.isArray(res)){
                const data:any = []
                res.forEach((bonus)=>{
                   //remove standard from options
                   if(standard != bonus.id){
                       data.push({
                           key: bonus.id,
                           value: bonus.id,
                           name:bonus.label,
                       })
                   }
                })
                setBonusOptions(data)
            }
        })()
    },[])

    React.useEffect(() => {
        if(!values[customInvestmentTypeFieldName]){
            initAllocations()
        }
    }, [addPlus(values["plus"], values["InvestmentType"]), Object.keys(allocationQuestion).length, values[customInvestmentTypeFieldName]]);

    React.useEffect(() => {
        (async () => {
            if (estimatorDataId) {
                const res = await estimationActions.getAllocationQuestions({
                    estimatorId: estimatorDataId,
                    carrierId: carrierId,
                });
                if (res) {
                    const allocationValues = {};
                    res.forEach((fields) => {
                        allocationValues[fields.code] = fields;
                    });
                    setAllocationQuestion(allocationValues);
                    setFieldValue(allocationFieldForm, allocationValues)

                    if ((clientAllocationsData.length > 0) && (carrierId === AllianzLifeCarrierDetail.value)) {
                        const caData = clientAllocationsData.map(item => item.questionCode);
                        const validQuestions = [
                            ...caData,
                            ...staticQuestions,
                        ];
                        const finalColumns = sortedQuestionsValues.filter(code => validQuestions.includes(code));
                        setColumns(finalColumns);
                    }
                }
            }
        })();
    }, [estimatorDataId]);

    React.useEffect(() => {
        const addRemoveData: string[] = sortedQuestionsValues.filter(item => !columns.includes(item));
        const cAButton = Object.fromEntries(
                (Object.entries(allocationQuestion) as [string, Item][])
                        .filter(([key]) => addRemoveData.includes(key))
                        .map(([key, value]) => [key, value.label])
        );
        setCheckAB(cAButton);

        if ((clientAllocationsData.length > 0) && (carrierId === AllianzLifeCarrierDetail.value)) {
            const caData = clientAllocationsData.map(item => item.questionCode);
            const selectedQuestions = allQuestion.filter(item => !staticQuestions.includes(item));
            const checkQuestions = selectedQuestions.every(val => caData.includes(val));
            if (checkQuestions) {
                setQuestionsToShow(allQuestion);
            } else {
                const validQuestions = [
                    ...caData,
                    ...staticQuestions,
                ];
                setQuestionsToShow(validQuestions);
            }
        }
    }, [columns, allocationQuestion]);

    const InvestmentMapper = {
        [InvestmentValues.SP500]: {
            desc: <Typography variant="caption">This option will measure the change only (no dividends) in the S&P index
                during the policy
                year and will credit any positive return up to the cap on policy anniversary (not during the year). It
                measures change only but cannot have a return below 0% (the floor).</Typography>,
            question: allocationMapper[InvestmentValues.SP500],
        },
        [InvestmentValues.SP500ALZ]: {
            desc: <Typography variant="caption">The S&P 500 Index represents a broad cross-section of common stocks
                traded on every major U.S. stock exchange. The index is a selection of 500 leading companies from 100
                distinct industry groups found in 10 leading American industrial market sectors.
            </Typography>,
            question: allocationMapper[InvestmentValues.SP500ALZ],
        },
        [InvestmentValues.SP500Futures]: {
            desc: <Typography variant="caption">The S&P 500 Futures Index ER is constructed from the front-quarter
                E-mini futures contract on the S&P 500. It tracks three-month futures on the S&P 500 Index. The S&P 500
                Futures Index ER uses an excess return methodology by tracking the price of futures. Futures prices
                reflect the expected future price of an index and account for expected dividends.
            </Typography>,
            question: allocationMapper[InvestmentValues.SP500Futures],
        },
        [InvestmentValues.lowVolatility]: {
            desc: <Typography variant="caption">Low volatility option is designed to have a more predictable return
                removing as much index volatility as possible. These options have no upper cap and typically have higher
                participation rates typically 1.6X+ of the index return (not including dividends).</Typography>,
            question: allocationMapper[InvestmentValues.lowVolatility],
        },
        [InvestmentValues.lowVolatilityALZ]: {
            desc: <Typography variant="caption">The Bloomberg US Dynamic Balance II ER Index is designed to help
                stabilize risk within your insurance policy over time. It seeks to achieve this by dynamically
                allocating daily between the Bloomberg US Equity Custom Futures ER Index and the Bloomberg US Aggregate
                Custom RBI Unfunded Index.
            </Typography>,
            question: allocationMapper[InvestmentValues.lowVolatilityALZ],
        },
        [InvestmentValues.Conservative]: {
            desc: <Typography variant="caption">The conservative strategy seeks to eliminate a zero credit by leveraging
                the Classic bonus and the guaranteed 1% bonus credited to the policy's annual accumulation value. It
                focuses avoiding a zero credit, but lower interest potential.
                <InfoIcon color={"primary"} onClick={() => {
                    setOpen(true);
                }} />
            </Typography>,
            question: allocationMapper[InvestmentValues.Conservative],
            prefix: 100 / allocationMapper[InvestmentValues.Conservative].length,
        },
        [InvestmentValues.ConservativePlus]: {
            desc: <Typography variant="caption">The conservative PLUS strategy seeks to guaranteed return each year to
                help you avoid receiving a zero credit in any year by leveraging the fixed allocation and the Classic
                bonus with the guaranteed 1% bonus credited to the policy's annual value. It focuses avoiding a zero
                credit, but lower interest potential.
                <InfoIcon color={"primary"} onClick={() => {
                    setOpen(true);
                }} />
            </Typography>,
            question: allocationMapper[InvestmentValues.ConservativePlus],
            prefix: 100 / allocationMapper[InvestmentValues.ConservativePlus].length,
        },
        [InvestmentValues.Moderate]: {
            desc: <Typography variant="caption">The moderate strategy helps limit zero credits in a given year; you need
                to be comfortable that you may have a zero return year,
                but are able to capture the 15% multiplier bonused opportunity.
                <InfoIcon color={"primary"} onClick={() => {
                    setOpen(true);
                }} />
            </Typography>,
            question: allocationMapper[InvestmentValues.Moderate],
            prefix: 100 / allocationMapper[InvestmentValues.Moderate].length,
        },
        [InvestmentValues.ModeratePlus]: {
            desc: <Typography variant="caption">The moderate PLUS strategy helps eliminate zero credits in a given year
                by leveraging the fixed allocation together with the Bonused allocations. This will guarantee a return
                each year and you are still able to capture the 15% multiplier bonused opportunity.
                <InfoIcon color={"primary"} onClick={() => {
                    setOpen(true);
                }} />
            </Typography>,
            question: allocationMapper[InvestmentValues.ModeratePlus],
            prefix: 100 / allocationMapper[InvestmentValues.ModeratePlus].length,
        },
        [InvestmentValues.Aggressive]: {
            desc: <Typography variant="caption">The aggressive mix is designed to help provide the potential for higher
                interest credits with the Select down years.
                You take the added risk with the 1% annual asset charge; however, you have greater accumulation
                potential with a 40% annual interest bonus.
                You need to be comfortable with the possibility of more zeros, but you have the opportunity for higher
                annual returns.
                <InfoIcon color={"primary"} onClick={() => {
                    setOpen(true);
                }} />
            </Typography>,
            question: allocationMapper[InvestmentValues.Aggressive],
            prefix: 100 / allocationMapper[InvestmentValues.Aggressive].length,
        },
        [InvestmentValues.AggressivePlus]: {
            desc: <Typography variant="caption">The aggressive PLUS mix is designed to help provide the potential for
                higher interest credits with the Select down years and eliminate zero credits by including the fixed
                allocation. You take the added risk with the 1% annual asset charge; however, you have greater
                accumulation potential with a 40% annual interest bonus.
                <InfoIcon color={"primary"} onClick={() => {
                    setOpen(true);
                }} />
            </Typography>,
            question: allocationMapper[InvestmentValues.AggressivePlus],
            prefix: 100 / allocationMapper[InvestmentValues.AggressivePlus].length,
        },

    };

    const selInvestment: any = InvestmentMapper[addPlus(values["plus"], values["InvestmentType"])];

    const selectOption = () => {
        switch (isAlZ) {
            case true:
                return [
                    { key: InvestmentValues.Conservative, name: "Conservative", text: "Conservative", value: InvestmentValues.Conservative },
                    { key: InvestmentValues.ConservativePlus, name: "Conservative Plus", text: "Conservative", value: InvestmentValues.ConservativePlus },
                    { key: InvestmentValues.Moderate, name: "Moderate", text: "Moderate", value: InvestmentValues.Moderate },
                    { key: InvestmentValues.ModeratePlus, name: "Moderate Plus", text: "Moderate", value: InvestmentValues.ModeratePlus },
                    { key: InvestmentValues.AggressivePlus, name: "Aggressive Plus", text: "Aggressive", value: InvestmentValues.AggressivePlus },
                    { key: InvestmentValues.Aggressive, name: "Aggressive ", text: "Aggressive", value: InvestmentValues.Aggressive },
                    { key: InvestmentValues.SP500Futures, name: "S&P Futures", text: "S&P Futures", value: InvestmentValues.SP500Futures },
                    { key: InvestmentValues.SP500ALZ, name: "S&P Annual PtP", text: "S&P Annual PtP", value: InvestmentValues.SP500ALZ },
                    { key: "custom", name: "Custom", text: "Custom", value: "custom" },
                ];
            default:
                return [
                    { key: InvestmentValues.SP500, name: "S&P 500", text: "S&P 500", value: InvestmentValues.SP500 },
                    { key: InvestmentValues.lowVolatility, name: "Low Volatility", text: "Low Volatility", value: InvestmentValues.lowVolatility },
                    { key: "custom", name: "Custom", text: "Custom", value: "custom" },
                ];
        }
    };

    React.useEffect(() => {
        let count = 0;
        if (carrierId === AllianzLifeCarrierDetail.value) {
            columns && columns.map((code) => {
                const label = getLabel(code);
                if (label) {
                    const doHaveBonus = allocationQuestion[code] && allocationQuestion[code].doHaveBonus;
                    const growthName = getGrowthFieldName(label, code);
                    const growthVal = allocationQuestion && allocationQuestion[code] && allocationQuestion[code].percentage;
                    if (doHaveBonus) {
                        const bonusTypeVal = allocationQuestion && allocationQuestion[code] && allocationQuestion[code].bonusType;
                        const bonusFieldName = getBonusFieldNameWithLabelPostfix(label, code, bonusTypeVal);
                        setFieldValue(bonusFieldName, bonusTypeVal); // Set the value of Column "Bonus Type"
                        count++;
                    }
                    setFieldValue(growthName, growthVal); // Set the value of Column "Current Rate"
                    setBonusCount(count);
                }
            });
        }
    }, [allocationQuestion, columns]);

    const percentageVal = (index: number, count: number) => {
        if (!count) return 0;

        const precision = 2;                 // number of decimals
        const factor = 10 ** precision;      // 100
        const totalInt = 100 * factor;       // 10000 (basis points)

        const base = Math.floor(totalInt / count);
        const remainder = totalInt - base * count;

        return (base + (index < remainder ? 1 : 0)) / factor;
    };

    React.useEffect(() => { // Set the value of Column "Percent"
        if (carrierId === AllianzLifeCarrierDetail.value) {
            columns && columns.map((code, index) => {
                const label = getLabel(code);
                if (label) {
                    const doHaveBonus = allocationQuestion[code] && allocationQuestion[code].doHaveBonus;
                    const percentageName = getPercentageFieldName(doHaveBonus, label, code);
                    if (doHaveBonus) {
                        setFieldValue(percentageName, percentageVal(index, bonusCount));
                    } else {
                        setFieldValue(percentageName, (values[percentageName] === undefined ? "" : values[percentageName]));
                    }
                }
            });
        }
    }, [bonusCount, allocationQuestion, columns]);

    const renderFields = () => {
        let fields: any [] = [];
        const object = {
            id: "InvestmentType",
            name: "InvestmentType",
            component:SelectField,
            className: "",
            options: selectOption(),
            color: "primary",
            label: "Premixes",
            key: (values[customInvestmentTypeFieldName] && values[customInvestmentTypeFieldName].toString()) || addPlus(values["plus"], values["InvestmentType"]),
            customAttribute:{
            value: values[customInvestmentTypeFieldName] ? "custom": addPlus(values["plus"], values["InvestmentType"]),
            onChange:(e) => {
                setFieldValue(customInvestmentTypeFieldName, false)
                // if (e.target.value == "custom") {
                //     e.preventDefault();
                // } else {
                    handleChange(e);
                // }
            },
        }
        };
        fields = [object];
        return fields;
    };

    const percentageField:any = {
        component: TextField,
        InputProps: {
            type:"number",
            max:100,
            min:0,
            autoComplete: "new-password",
            endAdornment:
                    <InputAdornment className="margin0" position="end">
                        %
                    </InputAdornment>,
        },
    }

    const totalPercentageField:any = {
        id: "totalPercentage",
        name: "totalPercentage",
        label: "Total Percentage",
        component: TextField,
        validate: (value)=>{
            if(required(value)){
                return required(value)
            }
            if(value != 100 ){
                return "Must equal 100%"
            }
        },
        autoComplete: "new-password",
        InputLabelProps:{
            shrink: true,
        },
        disabled:true,
        InputProps: {
            type:"number",
            max:100,
            min:0,
            endAdornment:
                    <InputAdornment className="margin0" position="end">
                        %
                    </InputAdornment>,
        },
    }

    const growthField:any = {
        id: "growth",
        name: "growth",
        label: "Growth",
        component: TextField,
        autoComplete: "new-password",
        validate: (value)=>{
            if( calculateGrowthRate() < distributionLoanRate(calculateGrowthRate(), carrierId, estimatorData['distributionLoanRate']) ){
                return `The average growth rate cannot be less than the current distribution loan rate of ${estimatorData['distributionLoanRate']} or the policy will lapse. Please reallocate options accordingly.`
            }
        },
        InputLabelProps:{
            shrink: true,
        },
        disabled:true,
        InputProps: {
            type:"number",
            max:100,
            min:0,
        }
    }

    const handleTotalPercentageField = () => {
        const factor = 100;
        const totalInt = columns.reduce((total, code) => {
            const label = getLabel(code);
            const doHaveBonus = allocationQuestion[code] && allocationQuestion[code].doHaveBonus;
            const percentageName = getPercentageFieldName(doHaveBonus, label, code);
            const value = Number(values[percentageName]);
            if (!isNaN(value)) {
                return total + Math.round(value * factor);
            }
            return total;
        }, 0);
        const totalPercentage = totalInt / factor;
        setFieldValue("totalPercentage", totalPercentage);
    };

    const bonusTypeField:any = {
        id: "bonusType",
        name: "bonusType",
        label: "Bonus Type",
        component: SelectField,
        // options: bonusOptions,
        validate: required,
    }

    // const bonusTypeFieldWithStandard = {...bonusTypeField, options: [...bonusOptions, standardBonusObject],  }

    const addAtIndex = async (label, code) => {
        if (estimatorDataId) {
            const res = await estimationActions.getAllocationQuestions({
                estimatorId: estimatorDataId,
                carrierId: carrierId,
            });

            if (res) {
                const newAllocationQuestion = res.filter(
                        item => item.label === label && !columns.includes(item.code),
                );

                if (newAllocationQuestion.length > 0) {
                    const index = columns.indexOf(code);
                    const updatedColumns =
                            index !== -1
                                    ? [
                                        ...columns.slice(0, index + 1),
                                        newAllocationQuestion[0].code,
                                        ...columns.slice(index + 1),
                                    ]
                                    : columns;
                    setColumns(updatedColumns);

                    const cAButton = Object.fromEntries(
                            Object.entries(checkAB).filter(
                                    ([key]) => !updatedColumns.includes(key)
                            )
                    );
                    setCheckAB(cAButton);
                }
            }
        }
    };

    const removeAtIndex = (label, code) => {
        const updatedColumns = columns.filter(item => item !== code);
        setColumns(updatedColumns);
        setCheckAB({ ...checkAB, [code]: label });
    };

    return (
            <Grid container spacing={2}>
                {isAlZ && <StepFourPopUp open={open} setOpen={setOpen} allocationQuestion={allocationQuestion}
                                         title={InvestmentValuesLabel[addPlus(values["plus"], values["InvestmentType"])]} />}
                <EstimationFormContext.Consumer>
                    {
                        (estimatorContextvalue: any) => {
                            const grpInfo: any = renderFields();

                            return (
                                    <>
                                        {grpInfo.map((field, index) => {
                                            switch (field.type) {
                                                case "radio":
                                                    return <>
                                                        <Grid item xs={12} sm={12}
                                                              md={field.name == "healthType" && callingFrom === "ESTIMATOR" ? 12 : 12}
                                                              key={index} className="mb15">
                                                            <FormControl>
                                                                <RadioGroup
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "unset",
                                                                        }}
                                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                                        {...field}
                                                                        key={values[field.name] && "InvestmentType"}
                                                                        defaultValue={values[field.name]}
                                                                        onChange={(e) => {
                                                                            if (!isSuffixExist(e.target.value)) {
                                                                                setFieldValue("plus", false);
                                                                            }
                                                                            handleChange(e);
                                                                        }}
                                                                >
                                                                    {
                                                                        field.options.map((opn: any) => {
                                                                            return <FormControlLabel className="mb0"
                                                                                                     value={opn.value}
                                                                                                     control={<Radio
                                                                                                             className="floatLeft pt0" />}
                                                                                                     label={opn.text} />;
                                                                        })
                                                                    }
                                                                </RadioGroup>
                                                                <EstimationErrorCommon errors={errors} name={field.name}
                                                                                       touched={touched} />
                                                                <span>
                                                                    {field && field.helperFieldText}
                                                                </span>
                                                            </FormControl>
                                                        </Grid>
                                                    </>;
                                                default:
                                                    return (
                                                            <Grid item xs={12} sm={6}
                                                                  md={field.name == "healthType" && callingFrom === "ESTIMATOR" ? 12 : 6}
                                                                  key={index} className="mb15">
                                                                <TextFieldCommon
                                                                        values={values}
                                                                        onChange={handleChange}
                                                                        {...field}
                                                                />
                                                                <span>
                                                                    {field && field.helperFieldText}
                                                                </span>

                                                                <EstimationErrorCommon errors={errors} name={field.name}
                                                                                       touched={touched} />
                                                            </Grid>
                                                    );
                                            }
                                        })}
                                        {/*{isAlZ && isSuffixExist(values["InvestmentType"]) && <FormControlLabel*/}
                                        {/*        control={*/}
                                        {/*            <Checkbox*/}
                                        {/*                    key={values["plus"]}*/}
                                        {/*                    className="pt0 pl15 pb0"*/}
                                        {/*                    checked={values["plus"]}*/}
                                        {/*                    onChange={handleChange}*/}
                                        {/*                    name="plus"*/}
                                        {/*                    color="primary"*/}
                                        {/*            />*/}
                                        {/*        }*/}
                                        {/*        label="PLUS(adds Fixed Account to the selected premix)"*/}
                                        {/*/>}*/}
                                        {values["InvestmentType"] && <>
                                            {user.role !== AccountType.Agent && <Typography variant="caption" component="strong"
                                                        className="floatLeft w100">For additional
                                                options, contact your agent</Typography>}
                                            <TableContainer>
                                                <Table className="materialUiTable" stickyHeader>
                                                <TableHead style={{ background: "#cfcfcf" }}>
                                                    <TableRow>
                                                        <TableCell padding="default">
                                                            <Typography
                                                                    variant="caption"
                                                                    component="strong"
                                                                    className="floatLeft w100 mb0">
                                                                {"Index Options"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell padding="default">
                                                            <Typography
                                                                    variant="caption"
                                                                    component="strong"
                                                                    className="floatLeft w100 mb0">
                                                                Bonus Type
                                                            </Typography>
                                                        </TableCell>

                                                        <TableCell padding="default">
                                                            <Typography
                                                                    variant="caption"
                                                                    component="strong"
                                                                    className="floatLeft w100 mb0" style={{minWidth: "180px"}}>
                                                                Percent
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell padding="default">
                                                            <Typography
                                                                    variant="caption"
                                                                    component="strong"
                                                                    className="floatLeft w100 mb0">
                                                                Current Rate
                                                            </Typography>
                                                        </TableCell>
                                                        {
                                                                (carrierId === AllianzLifeCarrierDetail.value) &&
                                                                <TableCell padding="default"></TableCell>

                                                        }
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {columns && columns.map((code) => {
                                                        const label = getLabel(code);
                                                        const doHaveBonus = allocationQuestion[code] && allocationQuestion[code].doHaveBonus;
                                                        const bonusTypeVal = allocationQuestion && allocationQuestion[code] && allocationQuestion[code].bonusType;
                                                        const bonusFieldName = getBonusFieldNameWithLabelPostfix(label, code, bonusTypeVal);
                                                        const percentageName = getPercentageFieldName(doHaveBonus, label, code);
                                                        const growthName = getGrowthFieldName(label, code);
                                                        const checkAddButton = Object.values(checkAB).includes(label);
                                                        const checkRemoveButton = (questionsToShow.indexOf(code) !== -1);
                                                        const checkIndexTitle = allocationQuestion && allocationQuestion[code] && checkRemoveButton;

                                                        return (<>
                                                                    <TableRow className={'light'}>
                                                                        <TableCell padding="default">
                                                                            {
                                                                                    checkIndexTitle &&
                                                                                    <Typography variant="caption"
                                                                                                component="strong"
                                                                                                className="floatLeft w100 mb15">
                                                                                        {label}
                                                                                    </Typography>
                                                                            }
                                                                            {
                                                                                    !checkIndexTitle &&
                                                                                    <><div className={classes.lineContainer}>
                                                                                        <div className={classes.vertical} />
                                                                                        <div className={classes.horizontal} />
                                                                                    </div></>
                                                                            }
                                                                        </TableCell>
                                                                        <TableCell padding="default"
                                                                                   style={{
                                                                                       whiteSpace: "pre-wrap",
                                                                                       // minWidth: 360,
                                                                                   }}>
                                                                            {
                                                                                doHaveBonus ?
                                                                                  <>  < TextFieldCommon
                                                                                             {...bonusTypeField}
                                                                                            name={bonusFieldName}
                                                                                            key={values[bonusFieldName]}
                                                                                            options={getBonusOptions(code)}
                                                                                            fullWidth
                                                                                            onSelectChange={(value: string)=>{
                                                                                                  const getCode = getCodeFromLabelAndBonus(allocationQuestion);
                                                                                                  const clientCode = getCode(label, value);
                                                                                                  if(allocationQuestion[clientCode].percentage) {
                                                                                                      setFieldValue(growthName, allocationQuestion[clientCode].percentage);
                                                                                                  }
                                                                                                  setFieldValue(customInvestmentTypeFieldName, true)
                                                                                                  values[bonusFieldName] = value
                                                                                                  validateForm(values)
                                                                                            }}
                                                                                            validate={(value) => {
                                                                                                      let error;
                                                                                                      if(!values[percentageName]){
                                                                                                          return
                                                                                                      }
                                                                                                      return required(value)
                                                                                                  }
                                                                                             }
                                                                                            values={values}
                                                                                            disabled={true}
                                                                                    /> <EstimationErrorCommon errors={errors}
                                                                                                    name={bonusFieldName}
                                                                                                    touched={{ [bonusFieldName]: true }} /></> : <></>
                                                                            }
                                                                        </TableCell>
                                                                        { <TableCell padding="default" align="center"
                                                                                    style={{ whiteSpace: "pre-wrap" }}>
                                                                            <TextFieldCommon
                                                                                    {...percentageField}
                                                                                    name={percentageName}
                                                                                    id={percentageName}
                                                                                    fullWidth
                                                                                    onBlur={() => {
                                                                                        handleTotalPercentageField();
                                                                                    }}
                                                                                    validate={(value) => {
                                                                                        const num = Number(value);
                                                                                        if (num < 0) return 'Must be Positive';
                                                                                        return undefined;
                                                                                    }
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        if(!values[customInvestmentTypeFieldName]) {
                                                                                            setFieldValue(customInvestmentTypeFieldName, true)
                                                                                        }
                                                                                        handleChange(e);
                                                                                    }}
                                                                                    values={values}
                                                                            />
                                                                            <EstimationErrorCommon errors={errors}
                                                                                                   name={percentageName}
                                                                                                   touched={{ [percentageName]:true }} />
                                                                        </TableCell>}

                                                                        { <TableCell padding="default" align="center"
                                                                                     style={{ whiteSpace: "pre-wrap" }}>
                                                                            <TextFieldCommon
                                                                                    {...percentageField}
                                                                                    name={growthName}
                                                                                    id={growthName}
                                                                                    fullWidth
                                                                                    disabled
                                                                                    values={values}
                                                                            />
                                                                        </TableCell>}
                                                                        {
                                                                                (carrierId === AllianzLifeCarrierDetail.value) &&
                                                                        <TableCell padding="default" align="center">
                                                                                {
                                                                                    doHaveBonus ?
                                                                                            <>
                                                                                                {
                                                                                                    checkAddButton && checkRemoveButton &&
                                                                                                    <>
                                                                                                        <Button className="floatLeft"
                                                                                                                color="primary"
                                                                                                                startIcon={
                                                                                                                    <AddCircleIcon />}
                                                                                                                onClick={() => {
                                                                                                                    addAtIndex(label, code);
                                                                                                                }}
                                                                                                        >
                                                                                                            Add Bonus
                                                                                                            Type
                                                                                                        </Button> <br />
                                                                                                    </>
                                                                                                }
                                                                                                {
                                                                                                    !checkRemoveButton &&
                                                                                                    <>
                                                                                                        <Button className="floatLeft"
                                                                                                                color="primary"
                                                                                                                startIcon={
                                                                                                                    <DeleteOutlineIcon
                                                                                                                            className="colorRed" />}
                                                                                                                onClick={() => {
                                                                                                                    removeAtIndex(label, code);
                                                                                                                }}
                                                                                                        >
                                                                                                            Remove Bonus
                                                                                                            Type
                                                                                                        </Button>
                                                                                                    </>
                                                                                                }
                                                                                            </> : <></>
                                                                                }
                                                                            </TableCell>
                                                                        }
                                                                        </TableRow>
                                                                    </>
                                                            );
                                                        })}
                                                    <TableRow>
                                                        <TableCell colSpan={3}>
                                                            <div className="floatRight w50">
                                                                <TextFieldCommon
                                                                        {...totalPercentageField}
                                                                        //name={getPercentageName()}
                                                                        //id={getPercentageName()}
                                                                        fullWidth
                                                                        onChange={handleChange}
                                                                        values={values}
                                                                />
                                                                <ErrorCommon errors={errors}
                                                                             name={totalPercentageField.name}
                                                                             touched={{"totalPercentage" : true }}/>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell colSpan={4}>
                                                            <div className="floatRight">
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={10}>
                                                                        <TextFieldCommon
                                                                                {...growthField}
                                                                                label={"Growth Rate"}
                                                                                fullWidth
                                                                                value={calculateGrowthRate().toFixed(2)}
                                                                                onChange={handleChange}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2} className="padding0">
                                                                        <Tooltip color="primary"
                                                                                 title={<>
                                                                                     <Typography variant="caption" className="f14">
                                                                                         The number you see here is a weighted average based on the allocations selected above.
                                                                                     </Typography>
                                                                                 </>}
                                                                                 arrow>
                                                                            <IconButton aria-label="Info">
                                                                                <InfoIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                </Grid>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                                </Table>
                                            </TableContainer>

                                            <ErrorCommon errors={errors}
                                                         name={growthField.name}
                                                         touched={{[growthField.name]:true}}/>
                                        </>}
                                    </>
                            );
                        }
                    }
                </EstimationFormContext.Consumer>
            </Grid>
    );
};

export default InvitationAllocations;